// frontend/src/components/layout/Header/Header.tsx

import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import './Header.css';

interface HeaderProps {
    onToggleSidebar: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, logout } = useAuth();

    const getPageTitle = (): string => {
        const path = location.pathname;

        const titles: Record<string, string> = {
            '/dashboard': 'Visão Geral',
            '/csv-upload': 'Adicionar Dados',
            '/datasets': 'Meus Dados',
            '/orc': 'Processamento',
            '/monitor': 'Acompanhamento',
            '/scientific-dashboard': 'Jornada dos Dados',
            '/analysis': 'Análise',
            '/eda': 'Exploração',
            '/eda-prepare': 'Preparação',
            '/ml': 'Modelos',
            '/ml-compare': 'Comparar Modelos',
            '/ml-predict': 'Predições',
            '/manual': 'Manual',
            '/empresas': 'Empresas',
            '/ciencia': 'Ciência',
            '/governanca': 'Governança',
        };

        return titles[path] ?? 'AutoSAGE';
    };

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <header className="header">
            <div className="header-left">
                <button
                    className="menu-toggle"
                    onClick={onToggleSidebar}
                    title="Alternar menu"
                >
                    ☰
                </button>
                <h1 className="page-title">{getPageTitle()}</h1>
            </div>

            {/* 👇 LINKS DE DESTAQUE (Sempre visíveis) 👇 */}
            <nav className="header-highlights">
                <Link to="/empresas" className={`highlight-link ${location.pathname === '/empresas' ? 'active' : ''}`}>
                    🏢 Empresas
                </Link>
                <Link to="/ciencia" className={`highlight-link ${location.pathname === '/ciencia' ? 'active' : ''}`}>
                    🔬 Ciência
                </Link>
                <Link to="/governanca" className={`highlight-link ${location.pathname === '/governanca' ? 'active' : ''}`}>
                    ⚖️ Governança
                </Link>
            </nav>

            <div className="header-right">
                <span className="current-date">
                    {new Date().toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    })}
                </span>
                {user && (
                    <span className="header-user" title={user.email}>
                        👤 {user.name}
                    </span>
                )}
                <button
                    className="header-logout"
                    onClick={handleLogout}
                    title="Sair da conta"
                >
                    Sair
                </button>
            </div>
        </header>
    );
};